import { ChevronRight, CloudUpload } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Collapse,
  Divider,
  Stack,
  styled,
  Switch,
  TextField,
  Typography,
  Zoom,
} from "@mui/material";
import { useFormik } from "formik";
import { useState, useEffect, useContext } from "react";
import {useLocation} from 'react-router-dom'
import * as Yup from "yup";
import FileUploader from "./FileUploader";
import { DataContext } from "../InitHrm";
import axios from "axios";
import { BaseHrmUrl } from "../../Intro/Constants";

function EmployeeReg(props) {

  const context = useContext(DataContext)
  const { stageChanger } = props;
  //states for button
  const [submitLoading, setSubmitLoading] = useState(false);
  const [image,setImage] = useState(null);
  const [error,setError] = useState(null);

  
  
  //show more contact fields
  const [more, setMore] = useState(false);
  //change btn name from more to less
  const [btnName, setBtnName] = useState("show more");
  //context okay
  
  const myFormik = useFormik({
    initialValues: {
      key: context.token,
      userName: "",
      firstName: "",
      middleName: "",
      lastName: "",
      nickName: "",
      email: "",
      primaryPhone: "",
      secondaryPhone: "",
      branch: context.profile.branch.branch_name,
      title: "",
      street: "",
      PoBox: "",
      City: "",
      county: "",
      website: "",
      birthday: new Date().toLocaleDateString(),
      label: "",
      edit: false,
    },

    validationSchema: Yup.object({
      userName: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      firstName: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      middleName: Yup.string().min(3, "must be more than 3 characters"),
      lastName: Yup.string()
        .required("Required")
        .min(3, "must be more than 3 characters"),
      email: Yup.string()
        .email()
        .matches(/^[a-z].+@./, "Invalid email"),
      primaryPhone: Yup.string()
        .required("Required")
        .min(10, "Invalid phone number")
        .max(13, "Invalid phone number")
        .matches(/^[0+]/, "Invalid phone number"),
    }),

    onSubmit: (values) => {
      setSubmitLoading(true)
      
  async function loadData(values) {
    try {
      const response = await axios.post(`${BaseHrmUrl}/create/user`,
        { ...values},
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
     
    setSubmitLoading(false);
    if(response.status===200){
        
      stageChanger(<FileUploader stageChanger={stageChanger} />);
    }
    else {
      setError(response.data.message)
    }
    } catch (error) {
      alert('Internal server error');
    }
  }
loadData(values)
}
  });

  //handle show more
  const handleShowMore = () => {
    const newBtnName = btnName === "show more" ? "show less" : "show more";
    setMore(!more);
    setBtnName(newBtnName);
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });


  return (
    <>
      <Zoom in={true} style={{ transitionDelay: "200ms" }}>
        <Card elevation={2}>
          <CardHeader title="New Person" />
          <Divider variant="middle" />
          <CardContent
            sx={{ display: "flex", flexDirection: "row", columnGap: 2 }}
          >
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              flexDirection={"column"}
              rowGap={3}
              padding={2}
            >
              
                  <Avatar sx={{ width:{ xs:64,sm:96,md:128,lg:192}, height: { xs:64,sm:96,md:128,lg:192} }} src={image}>{
                    <Button
                    component="label"
                    role={undefined}
                    variant="outlined"
                    tabIndex={-1}
                    sx={{ borderRadius: 4 }}
                    
                  >
                    Upload Profile
                    <VisuallyHiddenInput
                      type="file"
                      onChange={(event) => {
                        const file = event.target.files[0];
                        if (file) {
                          const reader = new FileReader();
                          reader.onloadend = () => {
                            setImage(reader.result);
                          };
                          reader.readAsDataURL(file);
                        }
                      }}
                      multiple={false}
                    />
                  </Button>
                    }</Avatar>
                  
                
            </Box>
            <Divider flexItem orientation="vertical"/>
            
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              flexDirection={"column"}
            >
              <form onSubmit={myFormik.handleSubmit}>
                <Box
                  my={1}
                  display={"flex"}
                  flexDirection={{ xs: "column", sm: "column", md: "row" }}
                >
                  <Stack>
                  {error ? (
                      <Typography color="error">
                        {error}
                      </Typography>
                    ) : null}
                    <TextField
                      size="small"
                      required
                      label="Username"
                      id="userName"
                      name="userName"
                      value={myFormik.values.userName}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />
                    {myFormik.errors.userName && myFormik.touched.userName ? (
                      <Typography color="error">
                        {myFormik.errors.userName}
                      </Typography>
                    ) : null}
                  </Stack>
                </Box>
                <Box
                  display="flex"
                  columnGap={2}
                  flexDirection={{ xs: "column", sm: "column", md: "row" }}
                  rowGap={1}
                >
                  <Stack>
                    <TextField
                      size="small"
                      required
                      label="First Name"
                      id="firstName"
                      name="firstName"
                      value={myFormik.values.firstName}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />
                    {myFormik.errors.firstName && myFormik.touched.firstName ? (
                      <Typography color="error">
                        {myFormik.errors.firstName}
                      </Typography>
                    ) : null}
                  </Stack>

                  <Stack>
                    <TextField
                      size="small"
                      label="Middle Name"
                      id="middleName"
                      name="middleName"
                      value={myFormik.values.middleName}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />
                    {myFormik.errors.middleName &&
                    myFormik.touched.middleName ? (
                      <Typography color="error">
                        {myFormik.errors.middleName}
                      </Typography>
                    ) : null}
                  </Stack>
                  <Stack>
                    <TextField
                      size="small"
                      required
                      label="Last Name"
                      id="lastName"
                      name="lastName"
                      value={myFormik.values.lastName}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />
                    {myFormik.errors.lastName && myFormik.touched.lastName ? (
                      <Typography color="error">
                        {myFormik.errors.lastName}
                      </Typography>
                    ) : null}
                  </Stack>

                  <TextField
                    size="small"
                    label="Nickname"
                    id="nickName"
                    name="nickName"
                    value={myFormik.values.nickName}
                    onChange={myFormik.handleChange}
                    onBlur={myFormik.handleBlur}
                  />
                </Box>
                <Box
                  display="flex"
                  columnGap={2}
                  mt={1}
                  flexDirection={{ xs: "column", sm: "column", md: "row" }}
                  rowGap={1}
                >
                  <Stack>
                    <TextField
                      size="small"
                      required
                      id="email"
                      name="email"
                      label="email"
                      value={myFormik.values.email}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />
                    {myFormik.errors.email && myFormik.touched.email ? (
                      <Typography color="error">
                        {myFormik.errors.email}
                      </Typography>
                    ) : null}
                  </Stack>

                  <Stack>
                    <TextField
                      size="small"
                      required
                      id="primaryPhone"
                      name="primaryPhone"
                      label="Mobile"
                      value={myFormik.values.primaryPhone}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />
                    {myFormik.errors.primaryPhone &&
                    myFormik.touched.primaryPhone ? (
                      <Typography color="error">
                        {myFormik.errors.primaryPhone}
                      </Typography>
                    ) : null}
                  </Stack>
                  <Stack>
                    <TextField
                      size="small"
                      id="secondaryPhone"
                      name="secondaryPhone"
                      label="Office Phone"
                      value={myFormik.values.secondaryPhone}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />

                    {myFormik.errors.secondaryPhone &&
                    myFormik.touched.secondaryPhone ? (
                      <Typography color="error">
                        {myFormik.errors.secondaryPhone}
                      </Typography>
                    ) : null}
                  </Stack>

                  <TextField
                    size="small"
                    id="branch"
                    name="branch"
                    label="Branch"
                    contentEditable={false}
                    disabled={true}
                    value={myFormik.values.branch}
                    onBlur={myFormik.handleBlur}
                  />
                </Box>
                <Collapse in={more} timeout="auto" unmountOnExit>
                <Stack  mt={2}>
                  <Typography>More Fields</Typography>
                  <Divider />
                  <Box
                    display="flex"
                    columnGap={2}
                    mt={1}
                    flexDirection={{ xs: "column", sm: "column", md: "row" }}
                    rowGap={1}
                  >
                    <TextField
                      size="small"
                      label="Title"
                      id="title"
                      name="title"
                      value={myFormik.values.title}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />

                    <TextField
                      size="small"
                      label="Street"
                      id="street"
                      name="street"
                      value={myFormik.values.street}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />

                    <TextField
                      size="small"
                      label="PO Box"
                      id="PoBox"
                      name="PoBox"
                      value={myFormik.values.PoBox}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />

                    <TextField
                      size="small"
                      label="Town"
                      id="city"
                      name="city"
                      value={myFormik.values.city}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />
                  </Box>
                  <Box
                    display="flex"
                    columnGap={2}
                    mt={1}
                    flexDirection={{ xs: "column", sm: "column", md: "row" }}
                    rowGap={1}
                  >
                    <TextField
                      size="small"
                      label="County"
                      id="county"
                      name="county"
                      value={myFormik.values.county}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />

                    <TextField
                      size="small"
                      label="Website"
                      id="website"
                      name="website"
                      value={myFormik.values.website}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />

                    <TextField
                      size="small"
                      label="Birthday"
                      id="birthday"
                      name="birthday"
                      value={myFormik.values.birthday}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />

                    <TextField
                      size="small"
                      label="Group"
                      id="label"
                      name="label"
                      value={myFormik.values.label}
                      onChange={myFormik.handleChange}
                      onBlur={myFormik.handleBlur}
                    />
                  </Box>
                </Stack>
                </Collapse>
                <Box
                  display={"flex"}
                  mt={2}
                  flexDirection={{ xs: "column", sm: "column", md: "row" }}
                >
                  <Button onClick={handleShowMore}>{btnName}</Button>
                  <LoadingButton
                    variant="contained"
                    loading={submitLoading}
                    type="submit"
                    sx={{ ml: "auto", borderRadius: 5 }}
                    endIcon={<ChevronRight />}
                  >
                    Save and Continue
                  </LoadingButton>
                </Box>
              </form>
            </Box>
          </CardContent>
        </Card>
      </Zoom>
    </>
  );
}

export default EmployeeReg;
